import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import ViewAttachedDocument from './ViewAttachedDocument';
import {
  findAttachmentByName,
  removeAttachment,
} from '../../actions/viewAttachment';
import ViewAttachedExcelDocument from './ViewAttachedExcelDocument';
import LoadingIndicator from '../Reusable/LoadingIndicator';
import withTranslations from '../../utils/HighOrderComponent';

class ModalForDocumentPreview extends React.Component {
  componentDidMount() {
    const { t, findAttachmentByName } = this.props || {};
    const documentName = this.props.documentName;
    const controllerReference = this.props.controllerReference;
    findAttachmentByName(documentName, controllerReference, t);
  }

  handleClose = () => {
    this.props.removeAttachment();
    this.props.handleClose();
  };

  extractFileFormat(documentName) {
    let format = documentName.substring(
      documentName.lastIndexOf('.') + 1,
      documentName.length
    );
    return format;
  }

  render() {
    const { documentAttachment, loading } = this.props.viewAttachment || {};
    const { embeddableAttribute } = documentAttachment || {};
    const { content } = embeddableAttribute || {};

    let format = this.extractFileFormat(this.props.documentName);

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`secondModal ${this.props.wideModal}`}
      >
        <div className="col-md-12">
          <Modal.Header closeButton>
            {loading ? (
              <LoadingIndicator />
            ) : (
              <Modal.Body className="col-md-12">
                {format !== 'pdf' && format !== 'xlsx' && format !== 'csv' && (
                  <ViewAttachedDocument content={content} fileType={format} />
                )}
                {(format === 'xlsx' || format === 'csv') && (
                  <ViewAttachedExcelDocument content={content} />
                )}
                {format === 'pdf' && (
                  <div className="pdf-attachment-wrapper">
                    <embed
                      src={`data:application/pdf;base64,${content}`}
                      width="100%"
                      height="100%"
                      style={{ borderStyle: '1px solid gray' }}
                      type="application/pdf"
                    />
                  </div>
                )}
              </Modal.Body>
            )}
          </Modal.Header>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  viewAttachment: state.viewAttachment,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  findAttachmentByName,
  removeAttachment,
})(withTranslations(ModalForDocumentPreview, 'ModalForDocumentPreview'));
